<template>
    <li class="nav-item dropdown notifications">
        <a class="nav-link dropdown-toggle position-relative" href="#" role="button" data-toggle="dropdown" aria-expanded="false" :title="notifTitle">
            <i class="icon bell-icon"></i>
            <span class="badge badge-warning" v-if="totalUnRead">{{ totalUnRead }}</span>
            <span class="badge badge-success" v-else>{{ totalUnRead }}</span>
        </a>

        <div class="dropdown-menu dropdown-menu-right animate slideIn">
            <template v-for="notification in notifications" :key="notification.id">
                <a class="dropdown-item" :class="notification.read ? 'read': ''" :href="`${orderViewUrl + notification.order_id}`">
                    <i class="icon order-icon" :class="notification.order.status"></i>

                    #{{ notification.order.id + ' ' + orderTypeMessages[notification.order.status]}}

                    <span class="text-muted float-right">{{ moment(notification.order.created_at).fromNow() }}</span>
                </a>

                <div class="dropdown-divider"></div>
            </template>

            <div class="dropdown-footer" :class="totalUnRead == 0 ? 'text-center' : ''">
                <a class="dropdown-footer pl-0" :href="viewAll">
                    {{ viewAllTitle }}
                </a>

                <button
                    class="btn btn-sm btn-primary float-right"
                    v-if="totalUnRead"
                    @click="readAll()"
                >
                    {{ readAllTitle }}
                </button>
            </div>
        </div>
    </li>
</template>

<script>
export default {

    props: [
        'notifTitle',
        'getNotificationUrl',
        'viewAll',
        'orderViewUrl',
        'pusherKey',
        'pusherCluster',
        'title',
        'viewAllTitle',
        'getReadAllUrl',
        'readAllTitle',
        'orderStatusMessages',
        'localeCode'
    ],

    data() {

        return {
            notifications: [],

            ordertype: {
                pending: {
                    icon: 'pending-icon',
                    message: 'Order Pending'
                },
                processing: {
                    icon: 'processing-icon',
                    message: 'Order Processing'
                },
                canceled: {
                    icon: 'canceled-icon',
                    message: 'Order Canceled'
                },
                completed: {
                    icon: 'completed-icon',
                    message: 'Order Completed'
                },
                closed: {
                    icon: 'closed-icon',
                    message: 'Order Closed'
                },
                pending_payment: {
                    icon: 'pending-icon',
                    message: 'Payment Pending'
                }
            },

            totalUnRead: 0,

            orderTypeMessages: JSON.parse(this.orderStatusMessages)
        }
    },

    mounted() {
        this.getNotification();

        if (this.pusherKey != undefined && this.pusherCluster != undefined) {
            Echo = new Echo({
                broadcaster: 'pusher',
                key: this.pusherKey,
                cluster: this.pusherCluster,
                encrypted: true
            });

            Echo.channel('notification').listen('.create-notification', (e) => {
                this.getNotification();
            });

            Echo.channel('notification').listen('.update-notification', (e) => {
                this.notifications.forEach((notification) => {
                    if (notification.order_id == e.id) {
                        notification.order.status = e.status;
                    }
                });
            });
        }
    },

    methods: {
        getNotification: function () {
            const params = {
                limit: 5,
                read: 0
            };

            let this_this = this;

            this.$http.get(this.getNotificationUrl, {
                    params: params
                })
                .then(function (response) {
                    this_this.notifications = response.data.search_results.data;
                    this_this.totalUnRead = response.data.total_unread;
                })
                .catch(function (error) {})
        },
        readAll: function () {
            let this_this = this;

            this.$http.post(this.getReadAllUrl)
                .then(function (response) {
                    this_this.notifications = response.data.search_results.data;

                    this_this.totalUnRead = response.data.total_unread;

                    window.flashMessages.push({
                        'type': 'alert-success',
                        'message': response.data.success_message
                    });

                    this_this.$root.addFlashMessages();
                })
                .catch(function (error) {})
        }
    }
}
</script>
